module.exports = __webpack_public_path__ + "img/bell.1a54692e.svg";